<template>
	<div class="container" v-loading="pageLoading">
		<el-row>
			<el-col :xl="16">
				<ul>
					<li>
						<span class="title">当前演出ID:</span>
						<span>{{ detailData.activityId }}</span>
					</li>
					<li>
						<span class="title">当前演出名称:</span>
						<span>{{ detailData.title }}</span>
					</li>
					<li>
						<span class="title">当前演出场地:</span>
						<span>{{ detailData.siteName }}</span>
					</li>
					<li>
						<span class="title">当前演出时间:</span>
						<div v-if="detailData.sessions && detailData.sessions.length">
							<div v-for="session in detailData.sessions" :key="session.id">
								{{ `${session.sessionName}:  ${session.startTime} 至 ${session.endTime}` }}
							</div>
						</div>
					</li>
					<li>
						<span class="title">冲突演出:</span>
						<div>
							<p class="color-danger">以下展示与当前演出在场地和时间上有冲突的演出</p>
							<el-table :data="detailData.clashSessions" border style="width: 100%;" size="small" stripe
								class="MT10">
								<el-table-column label="演出ID" prop="activityId" width="80px"></el-table-column>
								<el-table-column label="演出名称" prop="activityTitle">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.activityTitle"
											placement="top">
											<el-link :href="scope.row.siteLink"
												target="_blank">{{ scope.row.activityTitleStr || scope.row.activityTitle }}</el-link>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column label="冲突场地" prop="siteName"></el-table-column>
								<el-table-column label="冲突时间" width="170px">
									<template slot-scope="scope">
										<p>起: {{scope.row.startTime}}</p>
										<p>止: {{scope.row.endTime}}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</li>
					<li
						v-if="detailData.qrCodeCheck && detailData.qrCodeCheck.qrCodeList && detailData.qrCodeCheck.qrCodeList.length > 0">
						<span class="title">图片检测:</span>
						<div>
							<p class="color-danger">以下为系统自动检测到的包含二维码或引流，建议执行拒绝操作，或者审核通过后在管理后台修改</p>
							<table class="info-table MT10" style="width:100%">
								<tr>
									<th>位置</th>
									<th>检测类似</th>
									<th>图片</th>
								</tr>
								<tr v-for="(item, index) in detailData.qrCodeCheck.qrCodeList" :key="index">
									<td>
										<span v-if="item.sourceType === 'poster'">海报</span>
										<span v-else-if="item.sourceType === 'document'">演出详情图片</span>
									</td>
									<td><span v-if="detailData.qrCodeCheck.containsQRCode">包含二维码</span></td>
									<td>
										<el-image :src="item.sourceImage | coverImage(60,60)" fit="cover"
											:preview-src-list="[item.sourceImage]"></el-image>
									</td>
								</tr>
							</table>
						</div>

					</li>
					<li v-if="detailData.siteAuditRemark">
						<span class="title">场地特殊审核备注:</span>
						<span>{{ detailData.siteAuditRemark }}</span>
					</li>
					<li>
						<span class="title">审核备注:</span>
						<el-input type="textarea" :maxlength="100" v-model="form.msg" size="medium"
							placeholder="请输入审核备注" show-word-limit></el-input>
					</li>
					<li>
						<span class="title">推送至支付宝公域:</span>
						<el-checkbox v-model="form.pushAli" :true-label="1"
							:false-label="0">推送至支付宝公域，稍后可以在演出售票设置页查看详情</el-checkbox>
					</li>
					<li v-if="detailData.tourId">
						<span class="title">绑定巡演:</span>
						<el-checkbox v-model="form.autoTour" :true-label="1"
							:false-label="0">审核通过后自动加入巡演：{{detailData.tourName}}（巡演ID：{{detailData.tourId}}）</el-checkbox>
					</li>
					<li>
						<span class="title">自动建群:</span>
						<el-checkbox v-model="form.autoGroup" :true-label="1" :false-label="0">审核通过后自动建群</el-checkbox>
					</li>
					<li>
						<span class="title">定时上架:</span>
						<el-checkbox v-model="ReleaseAuto" :true-label="1"
							:false-label="0">审核通过定时上架(状态变成定时上架,期间前台不可见,主办方可以发起内容修改)</el-checkbox>
					</li>
					<li v-if="ReleaseAuto == 1 ">
						<span class="title">定时上架时间:</span>
						<el-date-picker v-model="form.onlineTime" type="datetime" placeholder="请输入定时上架时间"
							value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" size="small"></el-date-picker>
						<div class="ML10 color-warning line30">（定时上架时间必须大于当前时间）</div>
					</li>
					<li>
						<span class="title">第三方录入座位:</span>
						<el-checkbox v-model="form.seatEnter" :true-label="1" :false-label="0">勾选后按照规则对该演出的项目负责人发送三方录入座位提醒短信</el-checkbox>
					</li>
				</ul>
			</el-col>
		</el-row>
		<div class="btn-box MT20">
			<el-button @click="goBack" size="medium">返 回</el-button>
			<el-button type="success" @click="passOrReject(1,1)" size="medium"
				v-if="$utils.have('/activity/updateAudit/approved')">通过</el-button>
			<el-button type="danger" @click="passOrReject(0,1)" size="medium"
				v-if="$utils.have('/activity/updateAudit/auditReject')">拒绝</el-button>
			<el-button type="success" @click="passOrReject(1,0)" size="medium"
				v-if="$utils.have('/activity/updateAudit/approved')">免敏感词检测通过</el-button>
			<el-button @click="view" size="medium">查看演出详情</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			id: {
				type: [Number, String],
				default: null
			}
		},
		data() {
			return {
				pageLoading: true,
				detailData: {},
				form: {
					msg: '',
					autoGroup: 0,
					autoTour: 0,
					pushAli: 1,
					isCheckWord: '',
					onlineTime: '',
					seatEnter:0
				},
				ReleaseAuto: 0,
				redirect: this.$route.query.redirect || "/activityManage/onlineVerify/list",
			}
		},
		mounted() {
			this.getDetail(this.id);
		},
		methods: {
			getDetail(recordId) {
				this.pageLoading = true;
				this.$request({
						url: '/activity/onlineAudit/auditInfo',
						method: 'POST',
						params: {
							recordId
						}
					}).then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							const data = {
								...result
							};
							if (data.clashSessions && data.clashSessions.length) {
								data.clashSessions.forEach(item => {
									item.siteLink = `${process.env.VUE_APP_SSWAP_URL}/pages/activity/detail/detail?activityId=${item.id}`
									if (item.activityTitle && item.activityTitle.length > 40) {
										item.activityTitleStr = item.activityTitle.slice(0, 40) + '...'
									}
								})
							}
							if (data.tourId) {
								this.form.autoTour = 1;
							}
							//接口返回定时上架时间且不为空时，自动填充并勾选定时上架
							if (data.onlineTime) {
								this.form.onlineTime = data.onlineTime;
								this.ReleaseAuto = 1;
							}
							this.detailData = data;
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.finally(() => {
						this.pageLoading = false;
					});
			},
			passOrReject(operation, isCheckWord) {
				const data = {
					...this.form
				}
				data.operation = operation;
				data.recordId = this.id;
				data.id = this.detailData.activityId
				data.isCheckWord = isCheckWord
				if (operation == 0 && !data.msg) {
					return this.$message.error('拒绝通过时，请在备注填写拒绝原由');
				}
				if (this.ReleaseAuto == 1 && data.onlineTime == '') {
					return this.$message.error('定时上架时间不能为空！');
				}
				if (this.ReleaseAuto == 1 && data.onlineTime != '' && new Date(data.onlineTime.replace(/-/g, "/"))
					.getTime() < new Date().getTime()) {
					return this.$message.error('定时上架时间必须大于当前时间！');
				}
				data.onlineTime = this.ReleaseAuto == 1 ? data.onlineTime : ''
				const _msg = operation == 1 ? ' 确定通过审核?' : '确定拒绝审核通过?'
				//return
				
				var _releaseMsg =
					`前台是否可见: 按设定时间自动变成预售中, 期间前台不可见<br>经营平台修改: 期间主办在经营平台可以发起修改, 修改会生成演出修改审核<br>推送至支付宝公域: 等自动变成预售中的时候, 才会自动推送<br>自动微信小程序售票: 等自动变成预售中的时候, 才会自动售票(非 livehouse)<br>待推送列表: 等自动变成预售中的时候, 演出才会进入待推送列表<br>自动设置的一些参数: 三方渠道审核通过自动设置的服务费比例自动生效`
				if (this.ReleaseAuto == 1 && data.onlineTime != '') {

					this.$confirm(_releaseMsg, '定时上架', {
						center: false,
						dangerouslyUseHTMLString: true,
					}).then(() => {

						this.$confirm(_msg, '提示', {
							type: 'warning',
							center: true,
							closeOnClickModal: false
						}).then(() => {
							this.$request({
								url: '/activity/onlineAudit/audit',
								method: 'POST',
								data
							}).then(res => {
								let {
									state,
									msg
								} = res.data;
								if (state == 1) {
									// const resMsg = operation ? '审核通过' : '已拒绝通过';
									// this.$message.success(resMsg);
									// this.goBack();
									if (operation) {
										this.$confirm('注意：当前演出需要做上新推送，请到待推送列表进行推送操作', '审核', {
											confirmButtonText: '跳转至待推送演出列表',
											cancelButtonText: '暂不推送',
											dangerouslyUseHTMLString: true,
										}).then(() => {
											this.$router.push({
												path: '/activityManage/activityPush',
											});
										}).catch(() => {
											this.goBack();
										})
									} else {
										this.$message.success('已拒绝通过');
										this.goBack();
									}

								} else {
									if (state === 'audit.error') {
										msg = msg.replace(/\/n/g, '<br/>')
										this.$alert(msg, '审核', {
											confirmButtonText: '确定',
											dangerouslyUseHTMLString: true,
										}).catch(() => {})
									} else {
										this.$message.error(msg || "请求失败");
									}
								}
							}).catch(() => {
								this.$message.error("操作失败");
							})
						}).catch(() => {})



					}).catch(() => {

					})

				} else {



					this.$confirm(_msg, '提示', {
						type: 'warning',
						center: true,
						closeOnClickModal: false
					}).then(() => {
						this.$request({
							url: '/activity/onlineAudit/audit',
							method: 'POST',
							data
						}).then(res => {
							let {
								state,
								msg
							} = res.data;
							if (state == 1) {
								// const resMsg = operation ? '审核通过' : '已拒绝通过';
								// this.$message.success(resMsg);
								// this.goBack();
								if (operation) {
									this.$confirm('注意：当前演出需要做上新推送，请到待推送列表进行推送操作', '审核', {
										confirmButtonText: '跳转至待推送演出列表',
										cancelButtonText: '暂不推送',
										dangerouslyUseHTMLString: true,
									}).then(() => {
										this.$router.push({
											path: '/activityManage/activityPush',
										});
									}).catch(() => {
										this.goBack();
									})
								} else {
									this.$message.success('已拒绝通过');
									this.goBack();
								}

							} else {
								if (state === 'audit.error') {
									msg = msg.replace(/\/n/g, '<br/>')
									this.$alert(msg, '审核', {
										confirmButtonText: '确定',
										dangerouslyUseHTMLString: true,
									}).catch(() => {})
								} else {
									this.$message.error(msg || "请求失败");
								}
							}
						}).catch(() => {
							this.$message.error("操作失败");
						})
					}).catch(() => {})

				}


			},



			goBack() {
				this.$router.push({
					path: this.redirect,
				});
			},
			view() {
				window.open(`/activityManage/activity/edit/baseInfo/${this.detailData.activityId}`)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		li {
			display: flex;
			// line-height: 50px;
			margin: 15px 0;

			.title {
				width: 150px;
				text-align: right;
				margin-right: 10px;
				color: $--color-info;
				flex-shrink: 0;
			}

			&>div {
				overflow: hidden;
				width: 100%;
			}
		}

		.line30 {
			line-height: 30px;
		}

		// .btn-box{
		//     margin: 20px 0 0 100px;
		// }

		// .tips{
		//     color: #f78989;
		// }

	}

	.info-table {
		td {
			border-right: 1px #E4E7ED solid;
		}

		.el-image {
			width: 60px;
			height: 60px;
			margin-right: 5px;
		}
	}
</style>